import { jsx as _jsx } from "react/jsx-runtime";
import clss from 'classnames';
var Icon = function(props) {
    var type = props.type, className = props.className, size = props.size, onClick = props.onClick, _style = props.style, style = _style === void 0 ? {} : _style;
    var s = size ? {
        width: size,
        height: size
    } : {};
    var styles = Object.assign(style, s);
    return(/*#__PURE__*/ _jsx("svg", {
        style: styles,
        className: clss(className, "diox-font-".concat(type), 'diox-font', 'iconfont', 'inline-flex', 'items-center leading-none', {
            'cursor-pointer': !!onClick
        }),
        "aria-hidden": "true",
        onClick: function(e) {
            return onClick && onClick(e);
        },
        children: /*#__PURE__*/ _jsx("use", {
            xlinkHref: "#diox-font-".concat(type)
        })
    }));
};
export default Icon;
